import {api} from '~/shared/services/bffService';
import store from '~/shared/store';
import {selectCurrentAddress, selectCurrentDeliveryMethod} from '~/shared/store/selectors';
import {is401Error} from '~/shared/services/apiErrorService';
import {createSaKey} from '~/shared/utils/systemAnnouncement';

import {makeThunkAsyncActionCreator} from '../../redux-toolbelt';

import {SystemAnnouncementState} from './systemAnnouncementReducer';

export const getSystemAnnouncement = makeThunkAsyncActionCreator<never, SystemAnnouncementState['data']>(
  'getSystemAnnouncement',
  async () => {
    const state = store.getState();
    const currentAddress = selectCurrentAddress(state);
    const currentDeliveryMethod = selectCurrentDeliveryMethod(state);
    try {
      const result = await api.fetchSystemAnnouncement({
        longitude: currentAddress?.longitude,
        latitude: currentAddress?.latitude,
        cityId: currentAddress?.cityId,
        deliveryMethod: currentDeliveryMethod,
      });

      if (!result?.body && !result?.title) {
        return null;
      }

      return {
        ...result,
        fetchedFor: createSaKey(currentAddress, currentDeliveryMethod),
      };
    } catch (error: any) {
      // on 401 the error object should be passed forward, the 401 handling taking place outside the thunk
      if (is401Error(error)) {
        throw error;
      }
      if (error?.message) {
        throw new Error(error.message);
      }
      throw new Error('failed to fetch system announcement');
    }
  },
);
